export const ACCESS_ROLE = {
  ADMIN: "Admin",
  SUPER_ADMIN: "Super Admin",
  DEVELOPER: "Developer",
  CERTIFICATE_ADMIN: "Certificate Admin",
  NETS_ADMIN: "NETS Admin",
}